"use client"
import { Button } from "@/components/ui/button";
import CreateWorkerProfileModal from "@/components/views/modals/create-profile";
import { useState } from "react";

export default function CreateProfileButton() {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setModalIsOpen(true)}
        variant="secondary"
        className="py-3 flex gap-2
                    items-center font-bold text-sm bg-white border border-teal-500"
      >
        <span className="text-teal-500">Sen de Profil Oluştur</span>
      </Button>

      <CreateWorkerProfileModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
      />
    </>
  );
}
